// Behaviour of preloader
$(window).on('load', function () {
  if ($("#preloader").length > 0) {
    $("#preloader").delay(300).fadeOut('slow');
  }
});

window.$(document).ready(function () {

  function doTotal() {
    var total = 0.0;

    $(".fee").each(function () {
      var cost = parseFloat($(this).text());
      total += cost;
    });

    $(".sum").html(total.toFixed(2));
  }

  doTotal();

  let navigationBar = window.$('.header-nav-wrap'),
    mainHeader = window.$('#main-header'),
    triggerHeight = mainHeader.height() + 30;

  let resourceId = '';

  // Behaviour of sticky header
  function stickyHeader() {
    let loc = window.$(window).scrollTop();
    if (loc > triggerHeight) {
      navigationBar.addClass('sticky');
    } else {
      navigationBar.removeClass('sticky');
    }
    if (loc > triggerHeight + 20) {
      navigationBar.addClass('offset');
    } else {
      navigationBar.removeClass('offset');
    }
    if (loc > triggerHeight + 200) {
      navigationBar.addClass('scrolling');
    } else {
      navigationBar.removeClass('scrolling');
    }
  }

  if (!window.location.hash.length) {
    $(window).scrollTop(0);
  }
  stickyHeader();
  window.$(window).on('scroll', function () {
    stickyHeader();
  });

  $('.alert-box__close').click(function () {
    $(this).parent('.message-box').remove();
  });

  let imageUpdated = false;
  window.$('a.disabled').click(function (click) {
    click.preventDefault();
  });
  window.$('.upload-image').click(function (click) {
    click.preventDefault();
    window.$('input[type=file]', window.$(this).parent()).click();
  });

  // Uploade image and call cropper
  window.$('input.need-crop').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let image = document.getElementById(window.$(this).attr('id')).files[0];
    if (!image.type.match('image.*')) {
      return false;
    }

    let minHeight = 250;
    let minWidth = 700;

    let entityType = ($('#entity_type').length != 0) ? $('#entity_type').val() : '';

    if ((entityType == 'interview') || (entityType == 'talent_pool')) {
      minHeight = 700;
    }

    let fileId = (($('#file_id').length != 0) ? $('#file_id').val() : '');
    formData.append('image', image);
    formData.append('need_duplicate', 1);
    formData.append('mark_as_unexpired', (($('#mark_as_unexpired').length != 0) ? 1 : ''));
    window.$('strong', inputParent).text('Uploading').removeClass('text-danger').addClass('loading');

    resourceId = '';
    $('#resource_id').val(resourceId);

    if ((this).hasAttribute('data-type')) {
      entityType = $(this).data('type');
      fileId = $(this).data('file-id');
    }

    let cropperAspectRation = false;
    if ((entityType == 'talent_pool') || (entityType == 'interview')) {
      cropperAspectRation = true;
    } else if (entityType == 'motion') {
      cropperAspectRation = 16 / 9;
      minWidth = 700;
      minHeight = 250;
    } else if (entityType == 'label') {
      minHeight = 700;
      minWidth = 700;
      cropperAspectRation = 1;
    } else if (entityType == 'avatar') {
      minHeight = 550;
      minWidth = 550;
      cropperAspectRation = 1;
    } else if (entityType == 'news') {
      minHeight = 394;
      minWidth = 700;

      cropperAspectRation = 700 / 394;
    }

    if ((entityType == 'talent_pool') && $('input[name="talent_pool_id"]')) {
      formData.append('talent_pool_id', $('input[name="talent_pool_id"]').val());
    }

    formData.append('file_id', fileId);
    formData.append('entity_type', entityType);
    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        let data = response.data;


        imageUpdated = true;
        window.$('strong', inputParent).text('').removeClass('loading');
        window.$('.edit-crop.available').removeClass('available');
        let uploadButton = window.$('button.upload-image', inputParent);

        window.$('input[name=' + uploadButton.data('indicator-backup-name') + ']').val(response.data['backup']);

        let $input = $('#file_id').val(data.file_id ? data.file_id : '');

        //trigger Vuejs event for sync with v-model
        if ($input.length) {
          $input[0].dispatchEvent(new Event('input', {}));
        }

        if (data.cropPublicPath) {
          $('#cover_image').attr('src', data.cropPublicPath);
          $('#cover_image').css('display', 'inline-block');
          $('.image-cell').css('display', 'none');
        } else if ($('#entity_type').val() != 'published_book') {
          $('#cover_image').attr('src', data.public_path);
          $('#cover_image').css('display', 'inline-block');
          $('.image-cell').css('display', 'none');

          initCropper(response, inputParent, false, minWidth, minHeight, cropperAspectRation);
        }

        if (entityType == 'avatar') {
          setIllustratorAvatar(data.public_path);
        } else if (entityType == 'label') {
          setIllustratorDirectoryImage(data.public_path);
        }

      }).catch(() => {
        window.$('input.need-crop').val('');
        window.$('strong', inputParent).text(`Please upload correct image (.JPG, .PNG, ${minWidth}x${minHeight}px minimum)`).removeClass('loading').addClass('text-danger');
      });
  });

  window.$('.edit-crop.available').click(function (click) {
    click.preventDefault();
    if (!imageUpdated) {
      let inputParent = window.$(this).parent();
      let maxWidth = inputParent.data('max-width');
      let maxHeight = inputParent.data('max-height');

      resourceId = $(this).data('resource-id');
      $('#resource_id').val(resourceId);

      let aspectRatio = true;
      let type = window.$(this).data('resource-type');
      if (type == 'cms_published_book_thumbnail') {
        maxWidth = 350;
        maxHeight = 197;
        aspectRatio = 350 / 197;
      } else if ((type == 'news') || (type == 'motion')) {
        aspectRatio = 16 / 9;
        maxWidth = 700;
        maxHeight = 394;
      }

      axios.get('/ajax/image/get?id=' + window.$(this).data('resource-id') + '&type=' + type)
        .then((response) => {
          initCropper(response, inputParent, true, maxWidth, maxHeight, aspectRatio);
        });
    }
  });

  window.$('input.featured-need-crop').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let image = document.getElementById(window.$(this).attr('id')).files[0];
    if (!image.type.match('image.*')) {
      return false;
    }
    let entityType = ($('#entity_type').length != 0) ? $('#entity_type').val() : '';

    formData.append('image', image);
    formData.append('need_duplicate', 1);
    formData.append('entity_type', entityType);
    formData.append('file_id', (($('#file_id').length != 0) ? $('#file_id').val() : ''));
    window.$('strong', inputParent).text('Uploading').removeClass('text-danger').addClass('loading');
    resourceId = '';
    $('#resource_id').val(resourceId);

    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        window.$('strong', inputParent).text('').removeClass('loading');
        imageUpdated = true;

        let data = response.data;

        let cropperOptions = {};
        if ((entityType == 'week_illustrator') || (entityType == 'month_illustrator') || (entityType == 'featured_illustrator')) {
          $('#file_id').val(data.file_id);

          if (data.cropPublicPath) {
            $('#cover_image').attr('src', data.cropPublicPath);
            $('#cover_image').css('display', 'inline-block');
            $('.feature-thumbnail').css('display', 'none');
          } else {
            $('#cover_image').attr('src', data.public_path);
            $('#cover_image').css('display', 'inline-block');
            $('.feature-thumbnail').css('display', 'none');
          }

          cropperOptions.aspectRatio = false;

          if ((entityType == 'week_illustrator') || (entityType == 'month_illustrator')) {
            cropperOptions.aspectRatio = 387 / 290;
            cropperOptions.minCanvasWidth = 774;
            cropperOptions.minCanvasHeight = 580;
          } else if (entityType == 'featured_illustrator') {
            cropperOptions.aspectRatio = 773 / 580;
            cropperOptions.minCanvasWidth = 1546;
            cropperOptions.minCanvasHeight = 1160;
          }

        } else {
          window.$('.edit-crop.available').removeClass('available');
          let uploadButton = window.$('button.upload-image', inputParent);
          window.$('input[name=' + uploadButton.data('indicator-backup-name') + ']').val(response.data['backup']);
        }


        initCropperForFeatured(response, inputParent, true, cropperOptions);
      }).catch(() => {
        window.$('input.need-crop').val('');
        window.$('strong', inputParent).text('Please upload correct image (.JPG, .PNG, 700x700px minimum)').addClass('text-danger').removeClass('loading');
      });
  });
  window.$(document).on('click', '.featured-illustration-crop', function (click) {
    click.preventDefault();
    if (!imageUpdated) {
      let selectedElement = window.$(this);
      resourceId = $(this).data('resource-id');
      $('#resource_id').val(resourceId);
      axios.get('/ajax/image/get?id=' + window.$(this).data('resource-id') + '&type=' + window.$(this).data('resource-type'))
        .then((response) => {
          initCropperForFeatured(response, selectedElement, false);
        });
    }
  });
  window.$('input.talent-pool-need-crop').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let image = document.getElementById(window.$(this).attr('id')).files[0];
    if (!image.type.match('image.*')) {
      return false;
    }

    let entityType = $('#entity_type').val();

    formData.append('image', image);
    formData.append('need_duplicate', 1);
    formData.append('entity_type', entityType);
    formData.append('file_id', $('#file_id').val());
    window.$('strong', inputParent).text('Uploading').removeClass('text-danger').addClass('loading');

    if (entityType == 'talent_pool') {
      formData.append('talent_pool_id', $('input[name="talent_pool_id"]').val());
    }

    resourceId = '';
    $('#resource_id').val(resourceId);
    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {


        $('#file_id').val(response.data.file_id ? response.data.file_id : '');
        window.$('strong', inputParent).text('').removeClass('loading');
        imageUpdated = true;
        window.$('.edit-crop.available').removeClass('available');
        let uploadButton = window.$('button.upload-image', inputParent);
        window.$('input[name=' + uploadButton.data('indicator-backup-name') + ']').val(response.data['backup']);
        initCropperForTalentPool(response, inputParent, true);
      }).catch(() => {
        window.$('input.talent-pool-need-crop').val('');
        window.$('strong', inputParent).text('Please upload correct image (.JPG, .PNG, 700x700px minimum)').addClass('text-danger').removeClass('loading');
      });
  });
  window.$(document).on('click', '.talent-pool-crop', function (click) {
    click.preventDefault();
    if (!imageUpdated) {
      let selectedElement = window.$(this);
      resourceId = $(this).data('resource-id');
      $('#resource_id').val(resourceId);

      axios.get('/ajax/image/get?id=' + window.$(this).data('resource-id') + '&type=' + window.$(this).data('resource-type'))
        .then((response) => {
          initCropperForTalentPool(response, selectedElement, false);
        });
    }
  });

  // Simple upload image
  window.$('input.ajax-load').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let imageKey = window.$(this).attr('id');
    let image = document.getElementById(imageKey).files[0];
    if (!image.type.match('image.*')) {
      return false;
    }
    window.$('strong', inputParent).text('Uploading').addClass('loading').removeClass('text-danger');
    formData.append('image', image);
    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        window.$('strong', inputParent).text('').removeClass('loading');
        window.$('.image-cell', inputParent).css('background', "url('/" + response.data.image + "') no-repeat center center / 100% 100%");
      }).catch(() => {
        window.$('input.ajax-load').val('');
        window.$('strong', inputParent).text('Please upload correct image (.JPG, .PNG, 700x700px minimum)').addClass('text-danger').removeClass('loading');
      });
  });

  // Return default image
  window.$('button.default-image').click(function (click) {
    click.preventDefault();
    window.$('.image-cell', window.$(this).parent()).css('background', window.$(this).data('default-image'));
    let indicatorInputName = window.$('.upload-image', window.$(this).parent()).data('indicator-input-name');
    window.$('input[name=' + indicatorInputName + ']').val('');
    window.$('input[type=file]', window.$(this).parent()).val('');
  });

  //
  window.$('#payment-options').on('show.bs.modal', function (event) {
    let button = window.$(event.relatedTarget);
    let serviceId = button.data('service-id');
    let illustratorId = button.data('illustrator-id') === undefined ? null : button.data('illustrator-id');

    let modal = window.$(this);
    modal.find('button#paypal-payment').attr('data-service-id', serviceId);
    modal.find('button#worldpay-payment').attr('data-service-id', serviceId);

    modal.find('button#paypal-payment').attr('data-illustrator-id', illustratorId);
    modal.find('button#worldpay-payment').attr('data-illustrator-id', illustratorId);
  });

  //
  window.$('#shopping-cart-options').on('show.bs.modal', function (event) {
    let button = window.$(event.relatedTarget);
    let serviceId = button.data('service-id');
    let illustratorId = button.data('illustrator-id') === undefined ? null : button.data('illustrator-id');

    console.log(serviceId + ' --- ' + illustratorId);
    axios.post('/add-to-cart', {
      service_id: serviceId
    }).then((response) => {
      window.$('h3.modal-title.info').html(response.data);
    });
  });

  // remove from cart
  window.$('.remove-from-cart').on('click', function (click) {
    click.preventDefault();
    let uniqueId = window.$(this).data('unique-id');

    if (confirm('Are you sure?')) {
      axios.post('/remove-from-cart', {
        unique_id: uniqueId
      }).then((response) => {
        location.reload();
      });
    }
  });

  // Call send request to paypal
  window.$('#paypal-payment').click(function (click) {
    click.preventDefault();
    let serviceId = window.$(this).data('service-id');
    let illustratorId = window.$(this).data('illustrator-id') === undefined ? null : window.$(this).data('illustrator-id');
    let buyPublishedBooks = window.$('#pay-published-books').is(':checked');
    let talentPoolRecordId = window.$(this).data('talent-pool-record-id') === undefined ? null : window.$(this).data('talent-pool-record-id');

    axios.post('/payment/paypal', {
      service_id: serviceId,
      illustrator_id: illustratorId,
      buy_published_books: buyPublishedBooks,
      talent_pool_record_id: talentPoolRecordId
    }).then((response) => {
      window.location.replace(response.data['link']);
    });
  });

  // Shopping cart request to paypal
  window.$('#cart-paypal-payment').click(function (click) {
    click.preventDefault();

    axios.post('/cart/payment/paypal', {}).then((response) => {
      window.location.replace(response.data['link']);
    });
  });

  // Shopping cart request to paypal agency
  window.$('#cart-agency-paypal-payment').click(function (click) {
    click.preventDefault();

    axios.post('/cart/agency/payment/paypal', {}).then((response) => {
      window.location.replace(response.data['link']);
    });
  });

  // Send request to worldpay
  window.$('#worldpay-payment').click(function (click) {
    click.preventDefault();
    let serviceId = window.$(this).data('service-id');
    let illustratorId = window.$(this).data('illustrator-id') === undefined ? null : window.$(this).data('illustrator-id');
    let buyPublishedBooks = window.$('#pay-published-books').is(':checked');
    let talentPoolRecordId = window.$(this).data('talent-pool-record-id') === undefined ? null : window.$(this).data('talent-pool-record-id');

    axios.post('/payment/worldpay/set-redis-data', {
      service_id: serviceId,
      illustrator_id: illustratorId,
      buy_published_books: buyPublishedBooks,
      talent_pool_record_id: talentPoolRecordId
    }).then((response) => {
      window.location.replace(response.data['link']);
    });
  });

  // Shopping cart request to worldpay
  window.$('#cart-worldpay-payment').click(function (click) {
    click.preventDefault();

    axios.post('/payment/worldpay/pre-process', {}).then((response) => {
      window.location.replace(response.data['link']);
    });
  });

  // News approving
  window.$('.approve-news-post').click(function (click) {
    click.preventDefault();
    let newsPostId = window.$(this).data('news-post-id');

    axios.post('/dashboard/ajax/news/approve', {
      news_post_id: newsPostId,
    }).then((response) => {
      window.$(this).replaceWith('<span>' + response.data['status'] + '</span>');
    });
  });

  let pxShow = 500, // height on which the button will show
    fadeInTime = 400, // how slow/fast you want the button to show
    fadeOutTime = 400, // how slow/fast you want the button to hide
    scrollSpeed = 800, // how slow/fast you want the button to scroll to top. can be a value, 'slow', 'normal' or 'fast'
    goTopButton = window.$(".go-top");

  // Show or hide the sticky footer button
  window.$(window).on('scroll', function () {
    if ($(window).scrollTop() >= pxShow) {
      goTopButton.fadeIn(fadeInTime);
    } else {
      goTopButton.fadeOut(fadeOutTime);
    }
  });

  // Behaviour of go top btn
  window.$('.smoothscroll').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let target = this.hash;
    let $target = window.$(target);
    window.$('html, body').stop().animate({
      'scrollTop': $target.offset().top
    }, scrollSpeed, 'swing', function () {
      window.location.hash = target;
    });
  });

  // Initiate cropper for common places
  function initCropper(response, inputParent, updateOld = false, minWidth = 700, minHeight = 700, aspectRatio = false) {
    let modalHtml = window.$('#crop-image').clone();
    window.$('strong', inputParent).text('').removeClass('text-danger loading');
    let cropper = null;
    if (response.data.public_path) {
      window.$('#image-to-crop').attr('src', response.data.public_path);
    } else {
      window.$('#image-to-crop').attr('src', '/' + response.data['original_image']);
    }

    window.$('#crop-image').modal({
      backdrop: 'static'
    });
    let uploadButton = window.$('button.upload-image', inputParent);
    window.$('#crop-image').on('shown.bs.modal', function () {
      if (cropper) {
        cropper.destroy();
      }
      let image = document.getElementById('image-to-crop');

      // NOTE: if you change something is here, please don't forget change the same in the illustrator_dashboard.js and logo.js
      let options = {
        viewMode: 2,
        autoCropArea: 1,
        autoCrop: true,
        restore: false,
        // minCanvasWidth: minWidth + 10,
        // minCanvasHeight: minHeight + 10,
        crop: function (cropDetails) {
          if (Math.ceil(cropDetails.detail.width) < minWidth || Math.ceil(cropDetails.detail.height) < minHeight) {
            cropper.setData({width: minWidth, height: minHeight});
          }
        },
        zoom: function (e) {
          if (e.detail.ratio > 1) {
            e.preventDefault();
            cropper.zoomTo(0.99);
          }
        },
      };

      if (aspectRatio) {
        options.aspectRatio = aspectRatio;
      }

      cropper = new Cropper(image, options);

      window.$('.rotate-right').click(function (event) {
        event.preventDefault();
        cropper.rotate(45);
      });
      window.$('.rotate-left').click(function (event) {
        event.preventDefault();
        cropper.rotate(-45);
      });
      window.$('.zoom-in').click(function (event) {
        event.preventDefault();
        cropper.zoom(0.1);
      });
      window.$('.zoom-out').click(function (event) {
        event.preventDefault();
        cropper.zoom(-0.1);
      });
      window.$('.cancel-crop').click(function (event) {
        event.preventDefault();
        cropper.reset();
      });
      window.$('.save-crop').click(function (click) {
        click.preventDefault();
        if (!updateOld) {
          let cropInfo = cropper.getData(true);
          cropInfo.key = response.data['id'];
          cropInfo.fileKey = response.data['file_id'];
          cropInfo.image_extension = response.data['image_extension'];
          cropInfo.file_id = $('#file_id').val();
          cropInfo.entity_type = $('#entity_type').val();
          cropInfo.resource_id = $('#resource_id').val();

          if (cropInfo.entity_type == 'avatar') {
            cropInfo.entity_type = response.data['type'];
          }

          // apply crop changes and set
          axios.post('/ajax/image/transform', cropInfo)
            .then((response) => {
              let data = response.data;
              let $input =  window.$('input[name=' + uploadButton.data('indicator-input-name') + ']').val(response.data['id']);
              let $inputExtension = window.$('input[name=' + uploadButton.data('indicator-input-name') + '_extension]').val(response.data['image_extension']);

              if ($input.length) {
                $input[0].dispatchEvent(new Event('input', {}));
              }

              if ($inputExtension.length) {
                $inputExtension[0].dispatchEvent(new Event('input', {}));
              }

              cropper.destroy();
              window.$('#crop-image').modal('hide');

              if (data && data.cropPublicPath) {
                $('#cover_image').attr('src', data.cropPublicPath);
                $('#cover_image').css('display', 'inline-block');
                $('.image-cell').css('display', 'none');
              } else {
                window.$('.image-cell', inputParent).css('background', "url('/" + response.data['image'] + "') no-repeat center center / 100% 100% #dddddd");
              }

              if (response.data['type'] == 'illustrator_avatar') {
                setIllustratorAvatar(data['image']);
              } else if (response.data['type'] == 'illustrator_portfolio_label') {
                setIllustratorDirectoryImage(data['image']);
              }
            });
        } else {
          let cropInfo = cropper.getData(true);
          cropInfo.id = response.data['id'];
          cropInfo.fileKey = response.data['file_id'];
          cropInfo.image_extension = response.data['image_extension'];
          cropInfo.type = response.data['type'];
          cropInfo.resource_id = $('#resource_id').val();

          let entityType = $('#entity_type').val();
          let resoureId = $('.edit-crop').data('resource-id');
          if ((entityType == 'news') && resoureId) {
            cropInfo.resource_id = resoureId;
          }

          if (!cropInfo.type) {
            cropInfo.type = entityType;
          }

          // apply crop changes and set
          axios.post('/ajax/crop/update', cropInfo)
            .then((updatedCrop) => {
              response.data['image'] = updatedCrop.data['imagePath'] + "?" + new Date().getTime() + Math.floor(Math.random() * 100);
              cropper.destroy();

              window.$('#crop-image').modal('hide');

              if (inputParent.find('.edit-crop[data-resource-type="illustrator_avatar"]').length) {
                window.$('.owner-avatar img').attr('src', response.data['image']);
              }

              if (cropInfo.type == 'illustrator_avatar') {
                setIllustratorAvatar(response.data['image']);
              } else if (cropInfo.type == 'illustrator_portfolio_label') {
                setIllustratorDirectoryImage(response.data['image']);
              } else if (cropInfo.type == 'agency') {
                $('#cover_image').attr('src', response.data.image);
                $('.owner-logo img').attr('src', response.data.image);
              } else if (cropInfo.type == 'cms_published_book_thumbnail') {
                $('#cover_image').attr('src', response.data.image);
              } else if (entityType == 'news') {
                $('#cover_image').attr('src', response.data.image);
              }
            });
        }
      });
    });
    window.$('button.delete-image').click((click) => {
      click.preventDefault();
      cropper.destroy();
      window.$('#crop-image').modal('hide');
    });
    window.$('#crop-image').on('hidden.bs.modal', () => {
      window.$('#crop-image').after(modalHtml).remove();
    });
  }


  function setIllustratorAvatar(image) {
    $('.ill-avatar').attr('src', image);
    $('.ill-nav-avatar').attr('src', image);
  }

  function setIllustratorDirectoryImage(image) {
    $('.ill-thumb').attr('src', image);
  }

  // Initiate cropper for fetured illustrations
  function initCropperForFeatured(response, selectedElement, newFile = false, options = {}) {
    let modalHtml = window.$('#crop-image').clone();
    window.$('strong', selectedElement).text('').removeClass('text-danger loading');
    let cropper = null;

    let imageToCrop = '';
    if (response.data.public_path) {
      imageToCrop = response.data.public_path;
    } else {
      imageToCrop = '/' + response.data['original_image'];
    }

    window.$('#image-to-crop').attr('src', imageToCrop);
    window.$('#crop-image').modal({
      backdrop: 'static'
    });
    window.$('#crop-image').on('shown.bs.modal', function () {
      if (cropper) {
        cropper.destroy();
      }
      let image = document.getElementById('image-to-crop');

      let minCanvasWidth = 700,
        minCanvasHeight = 700;

      if (options.minCanvasWidth) {
        minCanvasWidth = options.minCanvasWidth;
      }

      if (options.minCanvasHeight) {
        minCanvasHeight = options.minCanvasHeight;
      }

      let aspectRatio = 1.33,
        entityType = $('#entity_type').val();

      if ((entityType == 'week_illustrator') || (entityType == 'month_illustrator') || (entityType == 'featured_illustrator')) {
        aspectRatio = 773 / 580;
      }

      let cropperOptions = {
        viewMode: 2,
        autoCropArea: 1,
        aspectRatio,
        autoCrop: true,
        restore: false,
        minCanvasWidth: minCanvasWidth,
        crop: function (cropDetails) {
          if (Math.ceil(cropDetails.detail.width) < minCanvasWidth || Math.ceil(cropDetails.detail.height) < minCanvasHeight) {
            cropper.setData({width: minCanvasWidth, height: minCanvasHeight});
          }
        },
        zoom: function (e) {
          if (e.detail.ratio > 1) {
            e.preventDefault();
            cropper.zoomTo(0.99);
          }
        },
      };

      if (options.hasOwnProperty('aspectRatio')) {
        if (options.aspectRatio === false) {
          delete cropperOptions.aspectRatio;
        } else {
          cropperOptions.aspectRatio = options.aspectRatio;
        }
      }


      cropper = new Cropper(image, cropperOptions);
      // console.log(cropper);
      window.$('.rotate-right').click(function (event) {
        event.preventDefault();
        cropper.rotate(45);
      });
      window.$('.rotate-left').click(function (event) {
        event.preventDefault();
        cropper.rotate(-45);
      });
      window.$('.zoom-in').click(function (event) {
        event.preventDefault();
        cropper.zoom(0.1);
      });
      window.$('.zoom-out').click(function (event) {
        event.preventDefault();
        cropper.zoom(-0.1);
      });
      window.$('.cancel-crop').click(function (event) {
        event.preventDefault();
        cropper.reset();
      });
      window.$('.save-crop').click(function (click) {
        click.preventDefault();

        let entityType = ($('#entity_type').length != 0) ? $('#entity_type').val() : '';

        let cropInfo = cropper.getData(true);
        cropInfo.key = response.data['id'];
        cropInfo.image_extension = response.data['image_extension'];
        cropInfo.original_image = response.data['original_image'];
        cropInfo.entity_type = entityType;
        cropInfo.file_id = (($('#file_id').length != 0) ? $('#file_id').val() : '');
        cropInfo.resource_id = resourceId;

        if (!newFile) {
          // apply crop changes and set
          axios.post('/ajax/image/crop-for-feature', cropInfo)
            .then((updatedCrop) => {
              window.$('input[name=' + selectedElement.data('indicator-input-name') + ']').val(updatedCrop.data['id']);
              window.$('input[name=' + selectedElement.data('indicator-input-name') + '_extension]').val(updatedCrop.data['image_extension']);
              cropper.destroy();
              window.$('#crop-image').modal('hide');

              if (updatedCrop.data.cropPublicPath) {
                $('#cover_image').attr('src', updatedCrop.data.cropPublicPath);
                $('#cover_image').css('display', 'inline-block');
                $('#feature-thumbnail').css('display', 'none');
                $('.feature-thumbnail').css('display', 'none');
              } else {
                window.$('.feature-thumbnail').css('background', "url('/" + updatedCrop.data['image'] + "') no-repeat center center / 100% 100% #dddddd");
              }
            });
        } else {
          let uploadButton = window.$('button.upload-image', selectedElement);
          // apply crop changes and set
          axios.post('/ajax/image/crop-for-feature', cropInfo)
            .then((updatedCrop) => {
              window.$('input[name=' + uploadButton.data('indicator-input-name') + ']').val(updatedCrop.data['id']);
              window.$('input[name=' + uploadButton.data('indicator-input-name') + '_extension]').val(updatedCrop.data['image_extension']);
              cropper.destroy();
              window.$('#crop-image').modal('hide');

              if (updatedCrop.data.cropPublicPath) {
                $('#cover_image').attr('src', updatedCrop.data.cropPublicPath);
                $('#cover_image').css('display', 'inline-block');
                $('#feature-thumbnail').css('display', 'none');
                $('.feature-thumbnail').css('display', 'none');
              } else {
                window.$('.feature-thumbnail').css('background', "url('/" + updatedCrop.data['image'] + "') no-repeat center center / 100% 100% #dddddd");
              }
            });
        }

      });
    });
    window.$('#crop-image').on('click', (click) => {
      if (click.target.getAttribute('id') == "crop-image") {
        window.$('.image-cell', selectedElement).css('background', "");
        $('form#add-illustration input#image').val('');
        $('form#add-illustration input[name="image_backup"]').val('');
      }
    });
    window.$('button.delete-image').click((click) => {
      click.preventDefault();
      cropper.destroy();
      window.$('#crop-image').modal('hide');
      window.$('.image-cell', selectedElement).css('background', "");
      $('form#add-illustration input#image').val('');
      $('form#add-illustration input[name="image_backup"]').val('');
    });
    window.$('#crop-image').on('hidden.bs.modal', () => {
      window.$('#crop-image').after(modalHtml).remove();
    });
  }

  // Initiate cropper for talent pool
  function initCropperForTalentPool(response, selectedElement, newFile = false) {
    let modalHtml = window.$('#crop-image').clone();
    window.$('strong', selectedElement).text('').removeClass('text-danger loading');
    let cropper = null;
    window.$('#image-to-crop').attr('src', '/' + response.data['original_image']);
    window.$('#crop-image').modal({
      backdrop: 'static'
    });
    window.$('#crop-image').on('shown.bs.modal', function () {
      if (cropper) {
        cropper.destroy();
      }
      let image = document.getElementById('image-to-crop');

      // NOTE: if you change something is here, please don't forget change the same in the illustrator_dashboard.js and logo.js
      cropper = new Cropper(image, {
        viewMode: 2,
        autoCropArea: 1,
        aspectRatio: 1,
        autoCrop: true,
        restore: false,
        minCanvasWidth: 700,
        crop: function (cropDetails) {
          if (Math.ceil(cropDetails.detail.width) < 700 || Math.ceil(cropDetails.detail.height) < 700) {
            cropper.setData({width: 700, height: 700});
          }
        },
        zoom: function (e) {
          if (e.detail.ratio > 1) {
            e.preventDefault();
            cropper.zoomTo(0.99);
          }
        },
      });
      // console.log(cropper);
      window.$('.rotate-right').click(function (event) {
        event.preventDefault();
        cropper.rotate(45);
      });
      window.$('.rotate-left').click(function (event) {
        event.preventDefault();
        cropper.rotate(-45);
      });
      window.$('.zoom-in').click(function (event) {
        event.preventDefault();
        cropper.zoom(0.1);
      });
      window.$('.zoom-out').click(function (event) {
        event.preventDefault();
        cropper.zoom(-0.1);
      });
      window.$('.cancel-crop').click(function (event) {
        event.preventDefault();
        cropper.reset();
      });
      window.$('.save-crop').click(function (click) {
        click.preventDefault();
        let cropInfo = cropper.getData(true);
        cropInfo.key = response.data['id'];
        cropInfo.image_extension = response.data['image_extension'];
        cropInfo.original_image = response.data['original_image'];
        cropInfo.file_id = $('#file_id').val();

        if (!newFile) {
          // apply crop changes and set
          axios.post('/ajax/image/crop-for-talent-pool', cropInfo)
            .then((updatedCrop) => {
              let data = updatedCrop.data;

              window.$('input[name=' + selectedElement.data('indicator-input-name') + ']').val(updatedCrop.data['id']);
              window.$('input[name=' + selectedElement.data('indicator-input-name') + '_extension]').val(updatedCrop.data['image_extension']);
              cropper.destroy();
              window.$('#crop-image').modal('hide');
              window.$('.image-cell').css('background', "url('/" + updatedCrop.data['image'] + "') no-repeat center center / 100% 100% #dddddd");


              if (data && data.cropPublicPath) {
                $('#cover_image').attr('src', data.cropPublicPath);
                $('#cover_image').css('display', 'inline-block');
                $('.image-cell').css('display', 'none');
              }
            });
        } else {
          let uploadButton = window.$('button.upload-image', selectedElement);
          // apply crop changes and set
          axios.post('/ajax/image/crop-for-talent-pool', cropInfo)
            .then((updatedCrop) => {
              let data = updatedCrop.data;

              window.$('input[name=' + uploadButton.data('indicator-input-name') + ']').val(updatedCrop.data['id']);
              window.$('input[name=' + uploadButton.data('indicator-input-name') + '_extension]').val(updatedCrop.data['image_extension']);
              cropper.destroy();
              window.$('#crop-image').modal('hide');
              window.$('.image-cell').css('background', "url('/" + updatedCrop.data['image'] + "') no-repeat center center / 100% 100% #dddddd");

              if (data && data.cropPublicPath) {
                $('#cover_image').attr('src', data.cropPublicPath);
                $('#cover_image').css('display', 'inline-block');
                $('.image-cell').css('display', 'none');
              }
            });
        }

      });
    });
    window.$('#crop-image').on('click', (click) => {
      if (click.target.getAttribute('id') == "crop-image") {
        window.$('.image-cell', selectedElement).css('background', "");
        $('form#add-illustration input#image').val('');
        $('form#add-illustration input[name="image_backup"]').val('');
      }
    });
    window.$('button.delete-image').click((click) => {
      click.preventDefault();
      cropper.destroy();
      window.$('#crop-image').modal('hide');
      window.$('.image-cell', selectedElement).css('background', "");
      $('form#add-illustration input#image').val('');
      $('form#add-illustration input[name="image_backup"]').val('');
    });
    window.$('#crop-image').on('hidden.bs.modal', () => {
      window.$('#crop-image').after(modalHtml).remove();
    });
  }

  // Btn in app header to enter dashboard or logout
  let ciAccount = window.$('.ci-account');
  ciAccount.children('.ci-account-avatar').on('click', function (e) {
    e.preventDefault();
    ciAccount.toggleClass('selected');
  });
  window.$(document).on('click', function (e) {
    if (!$(e.target).is('.ci-account-avatar, .ci-account-avatar img')) {
      ciAccount.removeClass('selected');
    }
  });

  // Close app modals
  window.$('.artwork-overlay__close').on('click', function () {
    var artworkOverlay = $('.artwork-overlay'),
      siteBody = $('body');

    if (artworkOverlay.hasClass('is-visible')) {
      artworkOverlay.removeClass('is-visible');
      siteBody.removeClass('overflow-hidden');
    } else {
      siteBody.addClass('overflow-hidden');
      artworkOverlay.addClass('is-visible');
    }
  });

  // Popups behaviour
  window.$('[data-popup-trigger]').on('click', function (event) {
    let triggerButton = window.$(this),
      triggerVal = window.$(this).data("popup-trigger"),
      popupOverlay = window.$('[data-popup-target=' + triggerVal + ']'),
      filterButton = popupOverlay.find('.popup-container__filter-buttons button[type="submit"]'),
      popupClose = popupOverlay.find('.popup-container__close'),
      siteBody = window.$('#top');

    event.preventDefault();
    siteBody.addClass('overflow-hidden');
    popupOverlay.addClass('is-visible');

    // close popup
    popupOverlay.on('click', function (event) {
      if (window.$(event.target).is(popupClose) || window.$(event.target).is(popupOverlay)) {
        event.preventDefault();
        window.$(this).removeClass('is-visible');
        siteBody.removeClass('overflow-hidden');
      }
    });

    // close popup when clicking the esc keyboard button
    window.$(document).keyup(function (event) {
      if (event.which === 27) {
        popupOverlay.removeClass('is-visible');
        siteBody.removeClass('overflow-hidden');
      }
    });

    // update filter button status and close popup
    if ((filterButton.length > 0) && !(triggerVal === 'sign-in')) {
      filterButton.on('click', function () {
        if (popupOverlay.find('input[type="checkbox"]:checked').length > 0) {
          triggerButton.addClass('is-active');
        } else {
          triggerButton.removeClass('is-active');
        }
        popupOverlay.removeClass('is-visible');
        siteBody.removeClass('overflow-hidden');
        /*event.preventDefault();*/
      });
    }
  });

  // filter toggles
  window.$('.content-bar__btn--filter-toggle').on('click', function () {
    $(this).toggleClass('is-active');
  });

  // Registration check terms agree
  var checkTerms = function () {
    if ($('#registration-terms-checkbox')[0].checked) {
      $('#registration-step-2-form button[type="submit"]').prop("disabled", false).addClass('btn--primary').removeClass('btn--disabled');
    } else {
      $('#registration-step-2-form button[type="submit"]').prop('disabled', true).removeClass('btn--primary').addClass('btn--disabled');
    }
  };
  if ($('#registration-terms-checkbox').length != 0) {
    checkTerms();
    $('#registration-terms-checkbox').change(checkTerms);
  }

  // Agencies auto-approve toggle
  window.$('input.news-auto-approve-option').click(function () {
    var autoApproved = window.$('input[name=news-auto-approve]:checked').val();

    axios.post('/dashboard/ajax/news/auto-approve', {
      auto_approved: autoApproved
    }).then(() => {
      window.location.reload();
    });
  });

  // closable alerts
  $(document).on('click', '.alert-box__close', function () {
    $(this).parent('.alert-box').hide();
  });

  // Collapsable info for collections
  if ($('.illustrator-collection__info-collapsable').length != 0) {
    if ($('.illustrator-collection__info-collapsable').height() > 210) {
      $('.illustrator-collection__info-collapsable').addClass('collapse');
      $('.illustrator-collection__info-collapsable-btn').show();
      $(document.body).trigger("sticky_kit:recalc");
    } else {
      $('.illustrator-collection__info-collapsable').removeClass('collapse');
      $('.illustrator-collection__info-collapsable-btn').hide();
    }

    $('.illustrator-collection__info-collapsable-btn').click(function () {
      $('.illustrator-collection__info-collapsable').removeClass('collapse');
      $('.illustrator-collection__info-collapsable-btn').hide();
      $(document.body).trigger("sticky_kit:recalc");
    });
  }
  

  // CMS: Talent pool - create
  if ($('#talent-pool-booking-form').length) {
    $('#talent-pool-booking-form #illustrators').on('change', function () {
      $('#talent-pool-booking-form .talent-pool__images-loading').show();
      $('#talent-pool-booking-form .masonry-list').hide();
      axios.get('/illustrator/' + $(this).val() + '/illustrations-weeks').then((response) => {
        $('#talent-pool-booking-form #weeks option').remove();
        $('#talent-pool-booking-form .masonry-list .masonry__brick').remove();

        $('#talent-pool-booking-form #weeks').val(null);
        $('#talent-pool-booking-form #weeks').append('<option disabled selected value> -- select period -- </option>');
        _.forEach(response.data.weeks, function (value, key) {
          $('#talent-pool-booking-form #weeks').append(`<option value="${key}">${value}</option>`);
        });

        _.forEach(response.data.illustrations, function (value) {
          let newImageElement;
          if (value.too_small) {
            newImageElement = `
                            <div class="grid-item-wrapper masonry__brick set-after">
                                <div class="custom-grid-item">
                                    <div class="custom-grid-item-thumbnail talent-pool-crop image-for-highlight text-center" data-indicator-input-name="image_crop" data-resource-id="${value.id}" data-resource-type="talent_pool">
                                        <img src="/${value.image}" alt="${value.title}">
                                        <div class="status-marker">Too Small</div>
                                    </div>
                                </div>
                            </div>
                        `;
          } else {
            newImageElement = `
                            <div class="grid-item-wrapper masonry__brick set-after">
                                <div class="custom-grid-item">
                                    <div class="custom-grid-item-thumbnail talent-pool-crop image-for-highlight text-center" data-indicator-input-name="image_crop" data-resource-id="${value.id}" data-resource-type="talent_pool">
                                        <img src="/${value.image}" alt="${value.title}">
                                    </div>
                                </div>
                            </div>
                        `;
          }

          $('#talent-pool-booking-form .masonry-list .masonry').append(newImageElement);
        });

        $('#talent-pool-booking-form .talent-pool__images-loading').hide();
        $('#talent-pool-booking-form .masonry-list').show();
        $('#talent-pool-booking-form .masonry-list .masonry').imagesLoaded(function () {
          let masonry = new window.masonry($('#talent-pool-booking-form .masonry-list .masonry')[0], {
            itemSelector: '.masonry__brick',
            percentPosition: true,
            resize: true
          });
          masonry.on('');
        });
      });
    });
  }
  

  // CMS: Illustrator create
  if ($('#illustrator-creating-step-2-form').length || $('#illustrator-update-by-admin').length) {
    if ($('select#agency').val() == 0) {
      $('.published-book-upgrade > *').show();
      $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('disabled', false);
    } else {
      $('.published-book-upgrade > *').hide();
      $('.published-book-upgrade-checkbox').show();
      $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('checked', true);
      $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('disabled', true);
    }
    $('select#agency').change(function () {
      if ($('select#agency').val() == 0) {
        $('.published-book-upgrade > *').show();
        $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('name', 'published_books');
        $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('checked', false);
        $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('disabled', false);
      } else {
        $('.published-book-upgrade > *').hide();
        $('.published-book-upgrade-checkbox').show();
        $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('checked', true);
        $('.published-book-upgrade-checkbox input[type="checkbox"]').prop('disabled', true);
        $('.published-book-upgrade-checkbox input[type="checkbox"]').removeAttr('name');
      }
    });

    if (!$('#published-books').prop('checked')) {
      $('.expiry-at-options input[type="date"]').prop('disabled', true);
    } else {
      $('.expiry-at-options input[type="date"]').prop('disabled', false);
    }
    $('#published-books').change(function () {
      if (!$('#published-books').prop('checked')) {
        $('.expiry-at-options input[type="date"]').prop('disabled', true);
      } else {
        $('.expiry-at-options input[type="date"]').prop('disabled', false);
      }
    });
  }

  if ($('.item-block__info-trigger').length) {
    let triggerButton = $('.item-block__info-trigger');

    triggerButton.on('click', function (event) {
      let itemInfo = $(this).next(),
        closeInfo = itemInfo.find('.item-block__info-close');

      event.preventDefault();
      itemInfo.addClass('is-visible');

      closeInfo.on('click', function (event) {
        event.preventDefault();
        itemInfo.removeClass('is-visible');
      });
    });
  }


  function replaceLetterInUrlParamsString(paramsString, letter) {
    let letterWasReplaced = false,
      resultString = '';

    if (!paramsString) {
      paramsString = '';
    }

    let params = paramsString.split('&');

    params.forEach((param) => {
      if (!param) return;

      let [key, value] = param.split('=');

      if (key == 'page') {
        return;
      } else if (key == 'show') {
        value = letter;
        letterWasReplaced = true;
      }

      resultString += key + '=' + value + '&';
    });

    if (!letterWasReplaced) {
      resultString += 'show=' + letter;
    }

    return resultString;
  }

  // Initiate selectric
  $('.content-bar__select').selectric({
    maxHeight: 300
  });
  $('#custom-sort').selectric().on('change', function () {
    let value = $(this).val();

    let url = window.location.href;
    let pathname = window.location.pathname;
    let urlParams = url.split("?")[1];


    let paramsString = replaceLetterInUrlParamsString(urlParams, value);

    window.location = pathname + '?' + paramsString;
  });
  if ($('#custom-sort').length) {
    let url = window.location.href;
    let show_parameter = getParameterByName('show', url);
    let index = parseSelectricIndex(show_parameter);

    $('#custom-sort').prop('selectedIndex', index).selectric('refresh');
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function parseSelectricIndex(letter) {
    switch (letter) {
    case 'random':
      return 0;
    case 'alphabetical':
      return 1;
    case 'a':
      return 2;
    case 'b':
      return 3;
    case 'c':
      return 4;
    case 'd':
      return 5;
    case 'e':
      return 6;
    case 'f':
      return 7;
    case 'g':
      return 8;
    case 'h':
      return 9;
    case 'i':
      return 10;
    case 'j':
      return 11;
    case 'k':
      return 12;
    case 'l':
      return 13;
    case 'm':
      return 14;
    case 'n':
      return 15;
    case 'o':
      return 16;
    case 'p':
      return 17;
    case 'q':
      return 18;
    case 'r':
      return 19;
    case 's':
      return 20;
    case 't':
      return 21;
    case 'u':
      return 22;
    case 'v':
      return 23;
    case 'w':
      return 24;
    case 'x':
      return 25;
    case 'y':
      return 26;
    case 'z':
      return 27;
    }
  }

  // Input without spaces
  $('.prevent-spaces').on('keydown', function (e) {
    if (e.which === 32) return false;
  });

  // Studio shots modal
  if ($('.studio-shots').length) {
    $(document).on('click', '.studio-shots__item img, .studio-shot-slides .item-block__thumb img', function () {
      $('.studio-shots-preview-modal .artwork-overlay__content img').attr('src', $(this).data('original-src'));
      if (!$('.studio-shots-preview-modal').hasClass('is-visible')) {
        $('.studio-shots-preview-modal').addClass('is-visible');
        $('body').addClass('overflow-hidden');
      }
    });
  }

  // Validation for news create page
  if ($('.news-create-form').length) {
    $('.news-create-form input[type="submit"]').click(function (e) {
      if (!validateNews()) {
        e.preventDefault();
      }
    });

    $('.news-create-form button[type="submit"]').click(function (e) {
      if (!validateNews()) {
        e.preventDefault();
      }
    });

    $('.news-create-form .news-cover input[type="file"]').change(function () {
      $('.news-cover .news-validation').remove();
    });
    $('.news-create-form input[name="title"]').change(function () {
      $('.news-title .news-validation').remove();
    });
    $('.post-images-block-images .image-input input[type="file"]').change(function () {
      $('.post-images-block-images .news-validation').remove();
    });

    let validateNews = function () {
      let isValid = true;

      $('.news-create-form .news-validation').remove();

      if (!$('.news-create-form').hasClass('_edit') && !$('.news-create-form input[name="image_crop"]').val()) {
        isValid = false;
        $('.news-create-form .news-cover .image-input').append('<div class="news-validation">Cover post is required</div>');
      }

      if (!$('.news-create-form input[name="title"]').val()) {
        isValid = false;
        $('.news-create-form .news-title ').append('<div class="news-validation">Title is required</div>');
      }

      $('.news-create-form .post-images-block').each(function () {
        // if ($(this).find('.image-input').length < 2) {
        //   isValid = false;
        //   $(this).find('.post-images-block-images').append('<div class="news-validation">Please add at least one supporting image</div>');
        // }

        if (!CKEDITOR.instances[$(this).find('textarea').attr('id')].getData()) {
          isValid = false;
          $(this).find('.post-images-block-desc').append('<div class="news-validation">Text field is required</div>');
        }
      });

      if (!isValid) {
        $('html, body').animate({
          scrollTop: $('.news-create-form .news-validation').first().parent().offset().top
        }, 300);
      }

      return isValid;
    };
  }

  // Validation for create talent pool page
  if ($('#create-talent-pool-record').length) {
    $('#create-talent-pool-record input[type="submit"]').click(function (e) {
      if ($('').css('display') == 'none') {
        e.preventDefault();
        $('.create-talent-pool__validation').show();
      } else {
        $('.create-talent-pool__validation').hide();
      }
    });
    $('#create-talent-pool-record input.need-crop').change(function () {
      $('.create-talent-pool__validation').hide();
    });
  }


  // Validation for interview create page
  if ($('.interview-create-form').length) {
    $('.interview-create-form button[type="submit"]').click(function (e) {

      localStorage.setItem('interview_submit_type', $(this).data('type'));

      let role = $(this).data('user');
      let type = $(this).data('save-button');

      if(!type) return;

      e.preventDefault();

      if (validateInterview(role)) {
        $(this).find('.inline-loader').show();
        $('.interview-create-form button[type="submit"]').prop('disabled', true);

        if (role === 'admin') {
          storeAdminInterview(this);
        } else {
          storeInterview(this, role);
        }
      }
    });

    $('.interview-create-form .interview-cover input[type="file"]').change(function () {
      $('.interview-cover .interview-validation').remove();
    });
    $('.interview-create-form input[name="name"]').change(function () {
      $('.interview-name .interview-validation').remove();
    });

    $('.interview-create-form input[name="position"]').change(function () {
      $('.interview-position .interview-validation').remove();
    });

    let validateInterview = function (role) {
      let isValid = true;

      $('.interview-create-form .interview-validation').remove();

      if ($('#cover_image').css('display') == 'none') {
        isValid = false;
        $('.interview-create-form .interview-cover .image-input').append('<div class="interview-validation">Cover interview is required</div>');
      }

      if ($('.interview-create-form input[name="name"]').length) {
        if (!$('.interview-create-form input[name="name"]').val()) {
          isValid = false;
          $('.interview-create-form .interview-name').append('<div class="interview-validation">Name is required</div>');
        }
      }

      if ($('.interview-create-form input[name="position"]').length) {
        if (!$('.interview-create-form input[name="position"]').val()) {
          isValid = false;
          $('.interview-create-form .interview-position').append('<div class="interview-validation">Position is required</div>');
        }
      }

      $('.interview-create-form .answer').each(function () {
        if ($(this).find('.interview-answer-question input[type="text"]').length) {
          if (!$(this).find('.interview-answer-question input[type="text"]').val()) {
            isValid = false;
            $(this).find('.interview-answer-question').append('<div class="interview-validation">Question is required</div>');
          }
        }

        if (role == 'admin') {
          if (!CKEDITOR.instances[$(this).find('textarea').attr('id')].getData()) {
            isValid = false;
            $(this).find('.interview-answer-text').append('<div class="interview-validation">Answer is required</div>');
          }
        } else {
          let text = CKEDITOR.instances[$(this).find('textarea').attr('id')].getData();
          let imagesInputsCount = $(this).find('.interview-answer-images .image-input').length;

          if (imagesInputsCount > 1 && !text) {
            isValid = false;
            $(this).parent().siblings('.interview-question').append('<small class="interview-validation">Answer field is required. You cant save only related images.</small>');
          }
        }
      });

      if (!isValid) {
        $('html, body').animate({
          scrollTop: $('.interview-create-form .interview-validation').first().parent().offset().top
        }, 300);
      }

      return isValid;
    };

    function storeInterviewQuestionInLocalStorage(question) {
      if(!question.answerText) return;

      let storageData = localStorage.getItem('interview');
      if (storageData) {
        storageData = JSON.parse(storageData);
      } else {
        storageData = {questions: []};
      }

      if (!storageData.hasOwnProperty('questions')) {
        storageData.questions = [];
      }

      let questionIndex = storageData.questions.findIndex(_question => _question.id == question.id);
      if (questionIndex === -1) {
        storageData.questions.push(question);
      } else {
        storageData.questions.splice(questionIndex, 1, question);
      }

      localStorage.setItem('interview', JSON.stringify(storageData));
    }

    function storeInterviewCoverImageInLocalStorage() {
      let storageData = localStorage.getItem('interview');
      if (storageData) {
        storageData = JSON.parse(storageData);
      } else {
        storageData = {questions: []};
      }

      if (!storageData.hasOwnProperty('questions')) {
        storageData.questions = [];
      }

      storageData.cover = {
        id: $('#file_id').val(),
        path: $('#cover_image').attr('src'),
      };

      localStorage.setItem('interview', JSON.stringify(storageData));
    }

    let expiredRequestHappened = false;
    let storeInterview = function (button, role) {
      let redirect = '/profile/interview';
      let draftId = $(button).data('id');
      let requestUrl = '/profile';

      if (role === 'agency') {
        redirect = '/dashboard/interview';
        requestUrl = '/dashboard';
      }
      let requestsCount = $('.interview-create-form .answer').length;

      function responseForRequests(formData) {
        if (requestsCount - 1 == 0) {
          if (expiredRequestHappened) {
            let msg = 'Your session has timed out. Refresh page to continue editing.';

            alert(msg);
            // location.reload();

            /* eslint-disable no-undef, no-unused-vars */
            // toastr.warning(msg);
            /* eslint-disable no-undef */

            // setTimeout(() => {
            // }, 5000);
          } else {
            localStorage.setItem('interview', '');
            localStorage.setItem('interview_submit_type', '');
            confirmRequest(formData);
          }
        } else {
          requestsCount--;
        }
      }

      function confirmRequest(formData) {
        let needSubmitFormAfter = $(button).data('need-submit-form');

        formData.append('save_button', $(button).data('save-button'));
        formData.append('draft_id', draftId ? draftId : 0);
        axios.post(requestUrl + '/ajax/interview/confirm', formData,
          {
            headers: {'content-type': 'multipart/form-data'}
          })
          .then((response) => {
            $(button).find('.inline-loader').hide();

            if (needSubmitFormAfter) {
              $(button).parent().find('#action').val($(button).data('save-button'));
              $(button).parent().submit();
            } else {
              window.location.href = response.data.redirect ? response.data.redirect : redirect;
            }
          }).catch(() => {
            $(button).find('.inline-loader').hide();
            window.location.href = redirect;
          });
      }

      let imageCrop = $('.interview-create-form').find('input[name="image_crop"]').val();
      let email = $('.interview-create-form').find('input[name="email"]').val();
      let coverImage = $('.interview-create-form .interview-cover').find('input[type="file"]')[0].files[0];

      let formData = new FormData();

      formData.append('image_crop', imageCrop);
      formData.append('email', email ? email : 0);

      if (coverImage) formData.append('image', coverImage);

      $('.interview-create-form .answer').each(function () {
        let questionId = $(this).parent().data('id');
        let imagesIds = $(this).find('.answer__images-ids').val();
        let answerText = CKEDITOR.instances[$(this).find('textarea').attr('id')].getData();
        let videoPath = $(this).find('input.video-path').val();
        let fileId = $('#file_id').val();
        let formData = new FormData();

        if (!fileId) {
          if ($('.image-input .interview-validation').length == 0) {
            $('.interview-create-form .interview-cover .image-input').append('<div class="interview-validation">Cover interview is required</div>');
          }

          $('.inline-loader').hide();
          $('.interview-create-form button[type="submit"]').prop('disabled', false);

          return;
        }

        formData.append('question_id', questionId);
        formData.append('answer', answerText);
        formData.append('sorted_images_ids', imagesIds);
        formData.append('video_path', videoPath);
        formData.append('file_id', fileId);
        formData.append('email', email ? email : 0);
        formData.append('draft_id', draftId ? draftId : 0);

        axios.post(requestUrl + '/ajax/interview', formData,
          {
            headers: {'content-type': 'multipart/form-data'}
          })
          .then(() => {
            responseForRequests(formData);
          }).catch(error => {

            //token expired
            // if (error.response.status == 419) {
            expiredRequestHappened = true;

            let images = [];
            $(this).find('.image-inputs .image-input').each(function () {
              let context = $(this);

              let imageId = context.find('.images_ids').val();
              images.push({
                id: imageId,
                imageId: imageId,
                imagePath: context.find('.small_image').attr('src'),
                type: 'image',
              });
            });

            let question = {
              id: questionId,
              answerText,
              images,
              videoPath,
              fileId,
              email,
              draftId,
              videoName: $(this).find('.video-name').text(),
            };

            storeInterviewCoverImageInLocalStorage();
            storeInterviewQuestionInLocalStorage(question);
            // }

            responseForRequests(formData);
          });
      });
    };

    let storeAdminInterview = function (button) {
      function confirmRequest(formData, draftId) {
        formData.append('save_button', $(button).data('save-button'));
        formData.append('draft_id', draftId ? draftId : 0);

        axios.post('/admin/ajax/interview/confirm', formData,
          {
            headers: {'content-type': 'multipart/form-data'}
          })
          .then(() => {
            $(button).find('.inline-loader').hide();
            window.location.href = '/admin/interviews';
          }).catch(() => {
            $(button).find('.inline-loader').hide();
            window.location.href = '/admin/interviews';
          });
      }

      let imageCrop = $('.interview-create-form').find('input[name="image_crop"]').val();
      let coverImage = $('.interview-create-form .interview-cover').find('input[type="file"]')[0].files[0];
      let email = $('.interview-create-form').find('input[name="email"]').val();
      let name = $('.interview-create-form').find('input[name="name"]').val();
      let position = $('.interview-create-form').find('input[name="position"]').val();
      let interviewId = $('.interview-create-form').find('input[name="interview_id"]').val();

      let formData = new FormData();

      formData.append('image_crop', imageCrop);
      formData.append('name', name);
      formData.append('position', position);
      formData.append('email', email ? email : 0);

      if (coverImage) formData.append('image', coverImage);
      if (interviewId) formData.append('interview_id', interviewId);

      axios.post('/admin/ajax/interview/cover', formData,
        {
          headers: {'content-type': 'multipart/form-data'}
        })
        .then((response) => {
          let draftId = response.data['draft_id'];

          let formData = new FormData();
          let parts = [];

          formData.append('draft_id', draftId ? draftId : 0);

          $('.interview-create-form .answer').each(function () {
            let imagesIds = $(this).find('.answer__images-ids').val();
            let answerText = CKEDITOR.instances[$(this).find('textarea').attr('id')].getData();
            let question = $(this).find('input[type="text"]').val();
            let question_id = $(this).find('input[type="text"]').data('question-id');
            let videoPath = $(this).find('input.video-path').val();

            parts.push({
              question: question,
              question_id: question_id,
              answer: answerText,
              sorted_images_ids: imagesIds,
              video_path: videoPath,
            });
          });

          axios.post('/admin/ajax/interview', {parts: parts, draft_id: draftId, file_id: $('#file_id').val()})
            .then(() => {
              confirmRequest(formData, draftId);
            }).catch(() => {
              alert('Interview wasnt save. Some problem with server.');
            });
        }).catch(() => {
          alert('Cover wasnt save. Some problem with server.');
        });
    };
  }

  // Content menu behaviour
  if ($('.content-bar__menu').length) {
    var menuContainer = $('.content-bar__menu'),
      menuPlaceholder = menuContainer.find('.placeholder a'),
      menuPlaceholderText = menuPlaceholder.text(),
      menuPlaceholderDefaultValue = 'Select',
      siteBody = $('body');

    // detect click event
    menuContainer.on('click', function (event) {
      if ((menuPlaceholder).is(':visible')) {

        // check if user has clicked the placeholder item (mobile view)
        if ($(event.target).is(menuPlaceholder) || $(event.target).is(menuContainer)) {
          updatePlaceholder(event);
        }
      }
    });
    menuContainer.find('.placeholder a').click(function (e) {
      e.preventDefault();
    });

    // close menu clicking outside the menu itself
    siteBody.on('click', function (e) {
      var eTarget = $(e.target);

      if (!eTarget.is('.content-bar__menu, .content-bar__menu *') && menuContainer.hasClass('is-open')) {
        updatePlaceholder();
      }
    });
  }

  // join page: url validation
  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locater
    if (!pattern.test(str)) {
      return false;
    } else {
      return true;
    }
  }

  // update placeholder
  function updatePlaceholder() {
    (menuPlaceholderDefaultValue == menuPlaceholder.text())
      ? menuPlaceholder.text(menuPlaceholderText)
      : menuPlaceholder.text(menuPlaceholderDefaultValue);
    menuContainer.toggleClass('is-open');

    return false;
  }

  $('#registration-step-2-form button[type="submit"]').click(function (e) {
    $('#registration-step-2-form .alert-box').remove();
    if ($('input#website').val() != '' && !validURL($('input#website').val())) {
      e.preventDefault();
      $('input#website').parent().append('<div class="alert-box alert-box--error hideit"><div>Please enter a valid web address.</div><i class="fa fa-times alert-box__close"></i></div>');
      $('html, body').animate({
        scrollTop: $('input#website').offset().top - 100
      });
    }
  });

  $('#buy-promo-boost-modal').on('show.bs.modal', function (event) {
    let button = $(event.relatedTarget),
      url = button.data('url'),
      name = button.data('name'),
      modal = $(this);

    modal.find('#buy-promo-boost-modal-url').attr("href", url);
    modal.find('#illustrator-name').text(name);
  });

  $('#shopping-cart-options-agency').on('show.bs.modal', function (event) {
    let button = $(event.relatedTarget),
      name = button.data('name'),
      illustrator_id = button.data('illustrator');

    console.log(name + ' -- ' + illustrator_id);
    axios.post('/add-to-cart', {
      service_id: 6,
      illustrator_id: illustrator_id
    }).then((response) => {
      window.$('h3.modal-title.info').html(response.data);
    });
  });

  $.fn.modal.Constructor.prototype.enforceFocus = function () {
    let modal_this = this;

    $(document).on('focusin.modal', function (e) {
      if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
        // add whatever conditions you need here:
        &&
        !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select') && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')) {
        modal_this.$element.focus();
      }
    });
  };

  $(document).on('click', 'button[type="submit"][value="bank_transfer"], button[type="submit"][value="cheque"]', function () {
    // $(this).prop('disabled', true);
  });
});